/* Dynamic Plot code copyright 2015 (c) Tuva Labs Inc. */
/**
 *
 * created by jpatel
 * Categorical attribute filter component
 * - allows user to update the data type of the attribute
 * - renders list of distinct category and allow user to include/exclude the category
 * - update the order of the category
 * Component will send the message which will be subscribed by the plot view to make the necessary change
 */

import React from 'react';
import NameDescEditComponent from './NameDescEditComponent.jsx';
import PlainButton from '../common/PlainButton';

class NewAttributeComponent extends React.Component {
    constructor (props) {
        super(props)
        // Placeholder attribute details
        var attributeObj = {
            name: 'New Attribute',
            longName: 'Custom Attribute Description',
            isDerived: true,
            formulaString: ''
        }

        // mediator.subscribe( "plot:containerResized", this.handleUnmountFilter );
        // mediator.subscribe( "toolBar:closeCurrentAttributeFilter", this.cleanFilter);
        // "plot:containerResized" - subscribe to it and handle the unmountFilter
        // attributeObj.stats.isNumeric() ? "numerical" : "categorical",
        this.state = {
            attributeObj: attributeObj,
            isNew: true,
        };
    }

    handleUnmountFilter = () => {
        // // Unmount it only if its smaller case card mode
        // if (!$("#chartArea").hasClass("slideLeft")){
        //     this.unmountFilter();
        //
        //     // Keep the state of the case card
        //     var record = {
        //         object: "filter",
        //         disableToggle: true
        //     };
        //     mediator.publish( "card:reinstateCaseCard", record );
        // }
    }

    cleanFilter = () => {
        // unmount the react filter component
        // this.unmountFilter();
    }

    unmountFilter = () => {

        // Use the same Id as whats been used to render the
        // react component for the container
        // var node = document.getElementById("caseDiv");
        //
        // mediator.remove( "plot:containerResized", this.handleUnmountFilter );

        // It will unmount the component from the memory
        // var unmountNode = ReactDOM.unmountComponentAtNode(node);
        // console.log(unmountNode);
    }

    handleClose = (event) => {
        this.props.onClose();
        // // unmount the react filter component
        // this.unmountFilter();
        //
        // // TODO - Revert back to the case cards - Check for selected attribute
        // var record = { object: "filter", caseCardScrollTop: this.props.caseCardScrollTop };
        // mediator.publish( "card:reinstateCaseCard", record );
    }


    // Callback function which will be called when Save/Cancel button is clicked at NameDescEditComponent
    handleNameDescEditClose = (isSave, val) => {
        let Dyn = this.props.Dyn;
        if(isSave) {
            Dyn.dataSet.addMetadataField({
                name: val.attrName,
                longName: val.attrLongName,
                formulaString: val.formulaString,
            });
        }
        this.handleClose();
        // TODO: We may not need forceUpdate in this case
        // this.forceUpdate();
    }


    getLoc = (str) => {
        let Dyn = this.props.Dyn;
        return Dyn.loc( str );
    }

    // To listen the keypress on the component
    onKeyPressed = (e) => {
        if(e.keyCode === 27) {
            // Focus close button on esc
            this.refs.closeButton.focus();
        }
    }

    componentDidMount = () => {
        this.refs.closeButton.focus();
    }

    render = () => {

        // render the add new attribute component
        return (
            <div className="tde-fill" onKeyDown={this.onKeyPressed} tabIndex="0" style={this.props.style}>
                <div className="tde-sliding-panel-header tde-divider-bottom">
                    <div><span
                        className="tde-ml-2 tde-h6 tde-font-weight-bold"
                        role="heading"
                        aria-level="1">{ this.getLoc('ADD NEW ATTRIBUTE CARD') }</span></div>
                    <PlainButton className="tde-mx-2 tde-close-attr-settings" ref="closeButton" title="Close" aria-label={this.getLoc('Close Add New Attribute Card')} onClick={this.handleClose}><i className="tde-i tde-i-remove"></i></PlainButton>
                </div>
                <div className="tde-sliding-panel-body tde-new-attribute-wrapper tde-card-content-bg-color">
                    <NameDescEditComponent
                        Dyn = {this.props.Dyn}
                        handleClose={this.handleNameDescEditClose} isNew={ this.state.isNew } attributeObj={ this.state.attributeObj } reduceCaseCardWidth = {this.props.reduceCaseCardWidth}/>
                </div>
            </div>
        );
    }
}

export default NewAttributeComponent;
